export default __webpack_public_path__ + "static/media/icon_home_active_new.cf5c9e0b.svg";